<template>
  <BittsLayout :is-page="true" class="analytics-page">
    <PageTitle title="Analytics" />
    <OmniDashboard dashboard-id="9a296aa2" />
    <RouterView />
  </BittsLayout>
</template>

<script setup lang="ts">
import { BittsLayout } from '@crossbeam/bitts';

import { useHead } from '@unhead/vue';

import OmniDashboard from '@/components/OmniDashboard.vue';
import PageTitle from '@/components/PageTitle.vue';

useHead({ title: 'Analytics - Crossbeam' });
</script>
